import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_80: FaireProductEntity = {
  token: "starter_collection_80",
  type: "product",
  name: "Parasol Champagne Vinegar",
  brandName: "Brightland",
  imageUrl:
    '"https://cdn.faire.com/fastly/c86bb3bec1b5b8aa696ab6c04478b22b81e80c8221567ed14de11828f8666e41.png?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=555',
  priceDollars: 27,
  msrpDollars: 54,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
